import { useEffect, useState } from "react";
export function useSpringPage(springPage) {
    const [rows, setRows] = useState([]);
    const [page, setPage] = useState();
    useEffect(() => {
        var _a, _b, _c, _d;
        if (springPage) {
            setRows((_a = springPage.content) !== null && _a !== void 0 ? _a : []);
            setPage({
                totalElements: (_b = springPage.totalElements) !== null && _b !== void 0 ? _b : 0,
                pageSize: (_c = springPage.size) !== null && _c !== void 0 ? _c : 0,
                pageIndex: (_d = springPage.number) !== null && _d !== void 0 ? _d : 0,
            });
        }
    }, [springPage]);
    return { rows, page };
}
//# sourceMappingURL=useSpringPage.js.map